import type { PropsWithChildren } from "react"
import type { AccessChipTone } from "./meta-access.utils"

/**
 * The status pill of Meta access, in the tones AdBlaster › Partnerships uses
 * (`StatusChip`), kept local so Settings does not pull in the partnerships table.
 */
const TONE_CLS: Record<AccessChipTone, string> = {
  green: "bg-system-green-700 text-white",
  amber: "bg-system-yellow-700 text-white",
  gray: "bg-system-gray-700 text-system-gray-200",
  blue: "bg-system-blue-700 text-white",
}

export default function AccessChip({
  tone,
  title,
  children,
}: PropsWithChildren<{ tone: AccessChipTone; title?: string }>) {
  return (
    <span
      data-tone={tone}
      title={title}
      className={`inline-block whitespace-nowrap rounded-full px-system-sm py-system-2xs text-xs font-medium ${TONE_CLS[tone]}`}
    >
      {children}
    </span>
  )
}
